module.exports = __webpack_public_path__ + "static/media/3.7dbcb64f.jpg";